import {createSlice} from '@reduxjs/toolkit'
import {HYDRATE} from 'next-redux-wrapper'
import {ProctoringSetupConfig} from "@/services/proctoring.service";

const initialState: ProctoringSetupConfig = {
    microphoneDeviceId: '',
    cameraDeviceId: '',
    headsetDetected: false,
    headsetNotHavingReason: '',
    cameraDetected: false,
    capturedImage: '',
}

const ProctoringSetupSlice = createSlice({
    name: 'proctoringSetupConfig',
    initialState,
    reducers: {
        setAudioDeviceConfig: (state, action: {
            payload: {
                microphoneDeviceId: string,
                headsetDetected?: boolean,
                headsetNotHavingReason?: string
            }
        }) => {
            state.microphoneDeviceId = action.payload.microphoneDeviceId
            state.headsetDetected = action.payload.headsetDetected || false
            state.headsetNotHavingReason = action.payload.headsetNotHavingReason || ''
        },
        setCameraDeviceConfig: (state, action: {
            payload: { cameraDeviceId: string, cameraDetected: boolean, capturedImage: string }
        }) => {
            state.cameraDeviceId = action.payload.cameraDeviceId
            state.cameraDetected = action.payload.cameraDetected || false
            state.capturedImage = action.payload.capturedImage || ''

        }
    },
    extraReducers: (builder) => {
        builder.addCase(HYDRATE, (state, action) => {
            if ('payload' in action && !action.payload) {
                const hydratedState = action.payload as any
                return {
                    ...state,
                    ...(hydratedState.proctoringSetupConfig || {}),
                }
            }
        })
    }
})
export const {setAudioDeviceConfig,setCameraDeviceConfig} = ProctoringSetupSlice.actions
export default ProctoringSetupSlice.reducer
